export default __webpack_public_path__ + "static/media/x-icon-followed-events.12b21400.svg";